import {INIT_APP} from '~/common/fabric/constants';
import {SET_ALL_ASSETS} from '../constants';
import {SET_FABRIC_TEMPLATE, SET_TEMPLATE_SNAPSHOT} from './constants';

const _t = window.fabricTemplate || {};

// TODO: remove default values here and rely on the INIT_APP to set all values
const initialState = {
  premium: false,
  templateName: '',
  displayName: '',
  metaDescription: null,
  eventType: '',
  editableArt: {default: []},
  artist: '',
  backgroundColor: '',
  stamps: [],
  stickers: [],
  envelopes: [],
  liners: [],
  backgrounds: [],
  allStamps: [],
  allStickers: [],
  allEnvelopes: [],
  allLiners: [],
  allBackgrounds: [],
  snapshot: null,
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FABRIC_TEMPLATE:
      return {...state, ...action.payload};
    case SET_TEMPLATE_SNAPSHOT:
      return {...state, snapshot: action.payload};
    case INIT_APP: {
      const T = action.payload.template;
      return {
        ...state,
        premium: T.premium,
        templateName: T.id,
        displayName: T.display_name,
        metaDescription: T.meta_description,
        eventType: T.event_type,
        editableArt: T.editable_art,
        artist: T.artist,
        backgroundColor: T.background_color,
        stamps: action.payload.stamps,
        stickers: T.stickers,
        envelopes: T.envelopes,
        liners: T.liners,
        backgrounds: action.payload.allBackgrounds,
        snapshot: null,
      };
    }
    case SET_ALL_ASSETS: {
      const {allStamps, allStickers, allLiners, allBackgrounds, allEnvelopes} =
        action.payload.allAssets;
      return {
        ...state,
        ...{
          allStamps,
          allStickers,
          allLiners,
          allBackgrounds,
          allEnvelopes,
          backgrounds: allBackgrounds,
          stamps: allStamps,
        },
      };
    }
    default:
      return state;
  }
};
